import util from '@bmp-vue/core/api/util'
const controller = 'Bravvis'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
})
